import React, { useState } from "react";

export default function PomodoroTypes() {
    const [type, setType] = useState("books");
    
    return (
        <div class="pomodoro-types">
            <img
                onClick={() => setType("books")}
                src={require("../assets/img/books.png")}
                style={{ opacity: type == "books" ? 1 : 0.4 }}
                className="pomodoro-types-image"
            />
            <img
                onClick={() => setType("microscope")}
                src={require("../assets/img/microscope.png")}
                style={{ opacity: type == "microscope" ? 1 : 0.4 }}
                className="pomodoro-types-image"
            />
            <img
                onClick={() => setType("briefcase")}
                src={require("../assets/img/briefcase.png")}
                style={{ opacity: type == "briefcase" ? 1 : 0.4 }}
                className="pomodoro-types-image"
            />
            <img
                onClick={() => setType("musicnote")}
                src={require("../assets/img/musicnote.png")}
                style={{ opacity: type == "musicnote" ? 1 : 0.4 }}
                className="pomodoro-types-image"
            />
        </div>
    );
}
